import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TranslationModule } from 'src/app/modules/translation.module';
import { WidgetSubAppTransitionComponent } from './widget-sub-app-transition.component';

@NgModule({
	declarations: [WidgetSubAppTransitionComponent],
	exports: [WidgetSubAppTransitionComponent],
	imports: [CommonModule, TranslationModule.forChild()],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class WidgetSubAppTransitionModule {}
